type StepCameraPose = {
    position: [number, number, number];
    target: [number, number, number];
    fov?: number;
};

type ResolvableStep = {
    type: 'bookmark' | 'customView';
    bookmarkId?: string;
    cameraPose?: StepCameraPose;
    transitionDuration?: number;
    pauseDuration?: number;
};

type BookmarkWithPose = {
    cameraPose: StepCameraPose;
};

const resolveStepCameraPose = (
    step: ResolvableStep,
    bookmarksById: Map<string, BookmarkWithPose>
) => {
    if (step.type === 'bookmark' && step.bookmarkId) {
        return bookmarksById.get(step.bookmarkId)?.cameraPose ?? null;
    }

    if (step.type === 'customView' && step.cameraPose) {
        return step.cameraPose;
    }

    return null;
};

const resolveStepDuration = (step: { transitionDuration?: number; pauseDuration?: number }) => {
    return Math.max(0, (step.transitionDuration ?? 0) + (step.pauseDuration ?? 0));
};

export { resolveStepCameraPose, resolveStepDuration };
export type { StepCameraPose, ResolvableStep, BookmarkWithPose };